module.exports = __webpack_public_path__ + "static/media/artOfPrecision-desktop.9d50b21a.jpg";